// app/auth/login/page.tsx
"use client";

import { Suspense } from "react";
import AccountLogin from "@/components/onboarding/login/login-component";
import AuthSidePanel from "@/components/onboarding/AuthSidePanel";

export default function LoginPage() {
  return (
    <div className="flex h-full w-full bg-white">
      <AuthSidePanel
        headline="Welcome Back"
        subline="Log in to manage your solar journey across Nigeria's leading renewable energy marketplace."
        features={["Access your quote history", "Track your orders", "Connect with providers"]}
      />
      <div className="flex w-full h-full min-h-screen md:w-2/3 flex-col justify-center items-center px-8 py-10 lg:px-16">
        <Suspense fallback={<div className="flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#17BC2E]"></div></div>}>
          <AccountLogin />
        </Suspense>
      </div>
    </div>
  );
}
